import { render, staticRenderFns } from "./ServiceLogs.vue?vue&type=template&id=5a07d81a&"
import script from "./ServiceLogs.vue?vue&type=script&lang=js&"
export * from "./ServiceLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports